// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4b5c1b68","977":"f924b556"}[chunkId] + ".chunk.js";
};